import { createReducer, on } from '@ngrx/store';
import { Distributor } from 'src/app/core/proto';
import { actionDistributorNamesListGet, actionDistributorNamesListGetSuccess } from 'src/app/core/store/distributors/distributors.actions';

export interface DistributorsState {
  distributorIds?: string[];
  distributors?: { [key: string]: Distributor };
  invalidDistributorUuids?: string[];
  isLoadingDistributor?: boolean;
  isLoadingDistributorList?: boolean;
}

const initialState: DistributorsState = {
  distributorIds: [],
  distributors: null,
  invalidDistributorUuids: [],
  isLoadingDistributor: true,
  isLoadingDistributorList: true,
};

export const distributorReducer = createReducer(
  initialState,
  on(actionDistributorNamesListGet, (state, action) => {
    return {
      ...state,
      distributorIds: action.body.distributorIds || [],
      isLoadingDistributorList: true,
    };
  }),
  on(actionDistributorNamesListGetSuccess, (state, action) => {
    return {
      ...state,
      distributors: action.payload.distributors || null,
      invalidDistributorUuids: action.payload.invalidDistributorUuids || [],
      isLoadingDistributorList: false,
    };
  }),
);
